import { render, staticRenderFns } from "./RecipesTitleBar.vue?vue&type=template&id=22e52b6e&scoped=true&"
import script from "./RecipesTitleBar.vue?vue&type=script&lang=js&"
export * from "./RecipesTitleBar.vue?vue&type=script&lang=js&"
import style0 from "./RecipesTitleBar.vue?vue&type=style&index=0&id=22e52b6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e52b6e",
  null
  
)

export default component.exports